<template>
  <f7-page>
    <f7-navbar :title="$t('title.settings')" :back-link="$t('action.back')"/>
    <f7-list form inline-labels>
      <f7-list-item :title="$t('label.language')" smart-select :smart-select-params="{openIn: $theme.ios ? 'sheet' : 'popover'}">
        <select name="language" v-model="locale" @change="setLanguage">
          <option value="en" :selected="locale === 'en'">{{$t('label.english')}}</option>
          <option value="de" :selected="locale === 'de'">{{$t('label.german')}}</option>
        </select>
      </f7-list-item>
      <list-input-toggle v-model="allowBiometric" v-if="biometricType" :label="$t(`label.${biometricType}`)"/>
    </f7-list>
  </f7-page>
</template>

<script>
  import cordovaHelpers from '@/utils/cordova-helpers'
  import ListInputToggle from '@/components/ListInputToggle'

  export default {
    name: 'settings-page',
    components: { ListInputToggle },
    data () {
      return {
        locale: localStorage.aio_locale,
        allowBiometric: !!(localStorage?.allow_biometric_auth),
      }
    },
    methods: {
      setLanguage() {
        localStorage.setItem('aio_locale', this.locale)
        location.reload()
      },
      toggleStatus () {
        this.allowBiometric = !this.allowBiometric
      }
    },
    watch: {
      allowBiometric: {
        immediate: true,
        handler (newVal) {
          localStorage.setItem('allow_biometric_auth', newVal)
        },
      },
    },
    computed: {
      biometricType () {
        // returns strings based on the i18n label (e.g. for label.fingerprint we return fingerprint)
        if (this.hasAndroidFingerprint) {
          return 'fingerprint'
        } else if (this.hasTouchID) {
          return 'touchId'
        } else if (this.hasFaceID) {
          return 'faceId'
        } else {
          // or null if there is no biometric
          return null
        }
      },
    },
    mixins: [cordovaHelpers]
  }
</script>

<style lang="scss" scoped>
  .md .inline-labels .item-label {
    width: 70%;
  }
</style>
